module.exports = __webpack_public_path__ + "media/images/sandwich-ebf2551b5ca6f55b0196e83ae642edbf.png";